import { Col, Row } from "react-bootstrap";
import { NavLink, useLocation } from "react-router-dom";
import amazon from "../../../../assets/icons/amazon.svg";
import appstore from "../../../../assets/icons/appstore.svg";
import cards from "../../../../assets/icons/multiCards.svg";
import starbucks from "../../../../assets/icons/starbucks.svg";
import {
  BegIcon, DashboardIcon, EyecircleIcon, FogsponIcon, GreenArrowIcon, NewCartIcon,
  RedArrowIcon, ReportcircleIcon, SettingscircleIcon, SnowcircleIcon,
} from "../../../../assets/icons/svgicons";
import uber from "../../../../assets/icons/uber.svg";
import { ROUTES } from "../../../../routes";
import Button from "../../../common/Button/Button";
import transactionIcon from "../../../../assets/icons/transactionIcon.svg";
import spendingIcon from "../../../../assets/icons/spendingIcon.svg";
import Earnedicon from "../../../../assets/icons/Earnedicon.svg";
import Slider from "react-slick";
import styles from "./STBLMoney.module.scss";
import AddPinModal from "../../../common/Modals/AddPinModal/AddPinModal";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  activeCardAction,
  applyCardApplicationAction,
  cardDataAction,
  cardDetailsAction,
  cardTranstionAction,
  generateOTPAction,
  getViewCardAction,
} from "../../../../features/user/userSlice";
import {
  isStblCardRestrictedCountry,
  SERVICESTYPE,
} from "../../../../utils/constants";
import { data } from "iso-3166-2";
import { use } from "react";
import { format } from "date-fns";
import CommonCardStbl from "./CommonCardStbl/CommonCardStbl";
import TopUpModals from "./TopUpModals/TopUpModals";
import ViewCardPin from "./ViewCardPin/ViewCardPin";
import toast from "react-hot-toast";
import NoContent from "../../../common/NoContent/NoContent";
import ViewCardOtpModal from "../../../common/Modals/ViewCardOtpModal/ViewCardOtpModal";
import CancelCardModal from "../../../common/Modals/CancelCardModal/CancelCardModal";

const STBLMoney = () => {
  const location = useLocation();
  const [show, setShow] = useState(false);
  const [donotLink, setDonotLink] = useState(false);
  const [spendingData, setSpendingData] = useState({});
  const [cardtransaction, setTransactionData] = useState([]);
  const [cancelCardShow, setCancelCardShow] = useState(false);
  const [cardData, setCardData] = useState({
    rain_card_id: '',
    last_four: '0000',
    expiry_month: "00",
    expiry_year: "0000",
    status: '',
    currentMonthSpending: 0,
    balance: {
      balance: '0.00',
      card_limit: 0,
      spent_limit: 0,
    },
    application: {
      first_name: '***',
      last_name: '***',
    },

  });
  const VIEW_TIME = 30;
  const [timer, setTimer] = useState(0);
  const [isViewDisabled, setIsViewDisabled] = useState(false);
  const [actionType, setActionType] = useState("");
  const [showtop, setShowtop] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const signUpData = useSelector((state) => state?.persist?.userInfo?.email);
  const cardType = localStorage.getItem("cardType")
  const [selectedCard, setSelectedCard] = useState(cardType || "CREDIT");
  const [cardDetails, setCardDetails] = useState({});
  const [showViewPin, setShowViewPin] = useState(false);
  const [update, setUpdate] = useState(false);
  const [modalTitle, setModalTitle] = useState("")
  const [showViewCardOtpModal, setshowViewCardOtpModal] = useState(false)
  const [showFullCard, setShowFullCard] = useState({ pan: "", cvc: "" })
  const [loading, setLoading] = useState(false)

  const Data = [
    { classcard: "", cardIcons: transactionIcon, label: "Card Balance", values: `$${cardData?.balance?.balance || 0}`, },
    { classcard: "light_green", cardIcons: spendingIcon, label: "Monthly Spending", values: `$${cardData?.currentMonthSpending || 0}`, },
    // { classcard: "light_blue", cardIcons: Earnedicon, label: "Credit Limit", values: `$54.80`,},
  ];
  const footerData = [
    {
      // tolink: ROUTES.FREEZE_CARD,
      iconlinks: <SettingscircleIcon />,
      label: "Freeze Card",
      modal: true,
    },
    { tolink: ROUTES.CARD_SETTINGS, iconlinks: <SnowcircleIcon />, label: "Card Settings", },
    { tolink: ROUTES.VIEW_CARD_PIN, iconlinks: <EyecircleIcon />, label: "Set/Update PIN", },
    // { tolink: ROUTES.SET_UPDATE_CARD_PIN, iconlinks: <EyecircleIcon />, label: "Set/Update PIN", },
    { tolink: ROUTES.REPORT_ISSUES, iconlinks: <ReportcircleIcon />, label: "Report Issue", },
  ];

  const rowdata = [
    {
      breakIcon: <NewCartIcon />, name: "In-Store Card Payment", amount: `$${spendingData?.POS?.totalAmount || 0}`,
      dateCategory: `${spendingData?.POS?.percentage || 0}`,
    },
    {
      breakIcon: <FogsponIcon />, name: "ATM Transaction", amount: `$${spendingData?.ATM?.totalAmount || 0}`,
      dateCategory: `${spendingData?.ATM?.percentage || 0}`,
    },
    {
      breakIcon: <BegIcon />, name: "Online Card Payment", amount: `$${spendingData?.ECOM?.totalAmount || 0}`,
      dateCategory: `${spendingData?.ECOM?.percentage || 0}`,
    },
    {
      breakIcon: <DashboardIcon />, name: "Others", amount: `$${spendingData?.ADMIN?.totalAmount || 0}`,
      dateCategory: `${spendingData?.ADMIN?.percentage || 0}`,
    },
  ];

  // ********** GET CARD DETAILS **********
  const getCardDetails = async () => {
    try {
      const res = await dispatch(cardDetailsAction());
      if (res?.status === 200) {
        const cards = Array.isArray(res?.data?.data) ? res.data.data : [];
        const debit = cards.find((c) => c.card_type === "DEBIT");
        const credit = cards.find((c) => c.card_type === "CREDIT");
        setCardDetails({ debit: debit, credit: credit })

        // Auto-switch if current selectedCard type is not available but the other one is
        if (!credit && selectedCard === "CREDIT" && debit) {
          setSelectedCard("DEBIT");
          localStorage.setItem("cardType", "DEBIT");
        } else if (!debit && selectedCard === "DEBIT" && credit) {
          setSelectedCard("CREDIT");
          localStorage.setItem("cardType", "CREDIT");
        }
      } else {
        setCardDetails({});
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    getCardDetails()
  }, [])

  const generateOTP = async (action) => {
    let serviceType = "";

    if (action === "activate") {
      serviceType = "CARD_ACTIVATE";
    } else if (action === "pin") {
      serviceType = "CARD_PIN";
    } else if (action === "freeze") {
      serviceType = "CARD_LOCK";
    }

    const data = { username: signUpData, type: SERVICESTYPE.EMAIL, service: serviceType, };

    try {
      const response = await dispatch(generateOTPAction(data));

      if (response?.status === 200) {
        if (action === "pin") navigate(ROUTES.VIEW_CARD_PIN);
      }
    } catch (error) {
      console.log("OTP Error:", error);
    }
  };
  const cardId = selectedCard === "CREDIT" ? cardDetails?.credit?.rain_card_id : cardDetails?.debit?.rain_card_id;
  const handleOtpSubmit = async (values) => {
    let payload = {
      otp: values?.otp,
      ...(values?.physicalLast4 && { last4: values.physicalLast4 }),
    };
    if (actionType === "activate") {
      payload.status = "active";
    } else if (actionType === "freeze") {
      payload.status = "locked";
    } else if (actionType === "unfreeze") {
      payload.status = "active";
    }
    try {
      const res = await dispatch(activeCardAction(payload, cardId));
      if (res?.status === 200) {
        setShow(false);
        setUpdate((prev) => !prev);
      }
      // if (actionType === "activate") {
      //   if (!donotLink) navigate(ROUTES.FREEZE_CARD);
      // }
    } catch (error) {
      console.log("OTP API Error:", error);
    }
  };

  const cardTranstionData = async () => {
    if (!cardId) return;
    try {
      const res = await dispatch(cardTranstionAction(cardId));

      if (res.status === 200) {
        const fullList = res?.data?.data || [];
        const spend = res?.data?.data?.categorySummary || {};
        const topFive = fullList?.transactions?.slice(0, 5);
        setTransactionData(topFive);
        setSpendingData(spend)
      }
    } catch (error) {
      console.log("Error");
    }
  };


  const cardDetailsData = async () => {
    if (!cardId) return;
    try {
      const res = await dispatch(cardDataAction(cardId));
      if (res.status === 200) {
        setCardData(res?.data?.data);
      }
    } catch (error) {
      console.log("Error");
    }
  };

  useEffect(() => {
    if (cardId) {
      cardTranstionData();
      cardDetailsData();
    }
  }, [cardId, update]);


  const isVirtual = cardData?.card_form === 'VIRTUAL';
  const isPhysicalActive = cardData?.card_form === 'PHYSICAL' && cardData?.status === 'active';
  const canShowDetails = isVirtual || isPhysicalActive;

  const viewCard = async (values) => {
    setLoading(true)
    try {
      const res = await dispatch(getViewCardAction(cardId, { otp: values?.otp }))
      if (res?.status === 200 || res?.status === 201) {
        setshowViewCardOtpModal(false);
        setShowFullCard(res?.data?.data);
        setTimer(VIEW_TIME);
        setIsViewDisabled(true);
      } else {
        console.log("API ERROR");
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (!timer) return;

    const interval = setInterval(() => {
      setTimer((prev) => {
        if (prev <= 1) {
          clearInterval(interval);
          setShowFullCard(null);
          setIsViewDisabled(false);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(interval);
  }, [timer]);


  const userCountry = useSelector(
    (state) => state?.persist?.userInfo?.country
  );

  if (isStblCardRestrictedCountry(userCountry)) {
    return (
      <section className={styles.stblMoney}>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          textAlign: 'center',
          padding: '20px'
        }}>
          <h3 style={{ color: '#00264d', marginBottom: '15px' }}>Service Unavailable</h3>
          <p style={{ fontSize: '1.6rem', color: '#666', maxWidth: '600px' }}>
            This service is not available in your country or region due to legal and regulatory restrictions.
          </p>
        </div>
      </section>
    );
  }

  return (
    <>
      <section className={styles.stblMoney}>
        <Row className="moneyrows">
          <Col lg={4} className="moneyleftcard">
            <div className={styles.stblMoney_left}>
              {/* <Slider {...settings}> */}
              {/* <div className={styles.cardtypebtns}>
                <label>Card Type</label>
                <div className={styles.cardtypebtns_innersec}>
                  {cardDetails?.credit &&
                    <Button
                      className={`${styles.btn_size} ${selectedCard === "CREDIT" ? styles.active : ""
                        }`}
                      variant="xtra_small"
                      onClick={() => {
                        localStorage.setItem("cardType", "CREDIT");
                        setSelectedCard("CREDIT")
                      }}
                    >
                      Credit Card
                    </Button>
                  }
                  {cardDetails?.debit &&
                    <Button
                      className={`${styles.btn_size} ${selectedCard === "DEBIT" ? styles.active : ""
                        }`}
                      variant="xtra_small"
                      onClick={() => {
                        localStorage.setItem("cardType", "DEBIT");
                        setSelectedCard("DEBIT")
                      }}
                    >
                      Debit Card
                    </Button>
                  }
                </div>
              </div> */}
              {/* TIMER */}
              {showFullCard?.pan && (
                <div className={styles.timer}>
                  Card visible for <strong>{timer}s</strong>
                </div>
              )}
              {selectedCard === "CREDIT" && (
                <div className={styles.multiCards}>
                  <CommonCardStbl
                    cardstatus={cardData?.card_form}
                    cardType="CREDIT"
                    cardNumber={
                      showFullCard?.pan
                        ? showFullCard.pan.replace(/(.{4})/g, "$1 ").trim()
                        : `**** **** **** ${canShowDetails ? cardData?.last_four : '****'}`
                    }
                    cardName={canShowDetails
                      ? `${cardData?.application?.first_name} ${cardData?.application?.last_name}`
                      : '**** ****'
                    }
                    cardDate={
                      canShowDetails
                        ? `${cardData?.expiry_month}/${cardData?.expiry_year}`
                        : '**/****'
                    }
                    cardCvc={
                      showFullCard?.cvc
                        ? showFullCard.cvc
                        : '***'
                    }
                    onClick={
                      showFullCard?.pan || cardData?.status !== "active"
                        ? undefined
                        : () => setshowViewCardOtpModal(true)
                    } />
                </div>
              )}
              {selectedCard === "DEBIT" && (
                <div className={styles.multiCards}>
                  <CommonCardStbl
                    cardstatus={cardData?.card_form}
                    cardType="DEBIT"
                    cardNumber={
                      showFullCard?.pan
                        ? showFullCard.pan.replace(/(.{4})/g, "$1 ").trim()
                        : `**** **** **** ${canShowDetails ? cardData?.last_four : '****'}`
                    }
                    cardName={canShowDetails
                      ? `${cardData?.application?.first_name} ${cardData?.application?.last_name}`
                      : '**** ****'
                    }
                    cardDate={
                      canShowDetails
                        ? `${cardData?.expiry_month}/${cardData?.expiry_year}`
                        : '**/****'
                    }
                    cardCvc={
                      showFullCard?.cvc
                        ? showFullCard.cvc
                        : '***'
                    }
                    onClick={
                      showFullCard?.pan || cardData?.status !== "active"
                        ? undefined
                        : () => setshowViewCardOtpModal(true)
                    } />
                </div>
              )}
              {/* </Slider> */}
              <div className={styles.action_box}>
                <h3 className="big">Spend your gold anywhere with STBL Visa</h3>
                <h5>Convert your precious metals to spending power instantly</h5>
                <div className={styles.action_box_btn}>
                  {/* <Button
                  onClick={() => {
                    setActionType("activate");
                    setShow(true);
                    setDonotLink(true);
                    generateOTP("activate");
                  }}
                  className={styles.btn_size}
                >
                  Activate Cards
                </Button> */}
                  <Button
                    onClick={() => {
                      setActionType("activate");
                      setShow(true);
                      setDonotLink(true);
                      generateOTP("activate");
                      setModalTitle("Activate Card")
                    }}
                    className={styles.btn_size}
                    disabled={cardData?.status === "active" || cardData?.status === "canceled"}
                  >
                    Activate Card
                  </Button>
                  <Button
                    className={styles.btn_size}
                    variant="bordered_white"
                    disabled={cardData?.status !== "active"}
                    onClick={() => {
                      setCancelCardShow(true)
                    }}
                  >
                    Cancel Card
                  </Button>
                  <Button
                    className={styles.btn_size}
                    variant="bordered_white"
                    onClick={() => setShowtop(true)}
                    disabled={cardData?.status !== "active" || selectedCard === "CREDIT"}
                  >
                    Top Up Card
                  </Button>
                </div>
              </div>
            </div>
          </Col>
          <Col lg={8} className="moneyrightcard">
            <div className={styles.stblMoney_right}>
              <div className={styles.stblMoney_right_head}>
                <Row>
                  {Data.map((items, index) => (
                    <Col
                      lg={6}
                      md={6}
                      sm={6}
                      xs={12}
                      key={index}
                      className="card_col"
                    >
                      <div
                        className={`${styles.cardtransaction} ${items.classcard}`}
                      >
                        <div className={styles.cardIcons}>
                          <img src={items.cardIcons} alt="card-icon" />
                        </div>
                        <div className={styles.text_sec}>
                          <label>{items.label}</label>
                          <h4 className="big">{items.values}</h4>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </div>
              <div className={styles.stblMoney_right_maincointent}>
                <Row>
                  <Col lg={6} md={6} sm={12} className="card_col">
                    <div className={styles.sending_breakdown}>
                      <div className={styles.sending_breakdown_head}>
                        <h4>Spending Breakdown</h4>
                      </div>
                      <ul>
                        {rowdata.map((items, index) => (
                          <li key={index}>
                            <div className={styles.sending_breakdown_left}>
                              <div className={styles.sending_icon}>
                                {items.breakIcon}
                              </div>
                              <div className={styles.textbox}>
                                <h6 className="mb-0">{items.name}</h6>
                              </div>
                            </div>
                            <div className={styles.sending_breakdown_right}>
                              <h6>{items.amount}</h6>
                              <p>{items.dateCategory}</p>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </div>
                  </Col>
                  <Col lg={6} md={6} sm={12} className="card_col">
                    <div className={styles.recent_transactions}>
                      <div className={styles.recent_transactions_head}>
                        <h4>Recent transactions</h4>
                        <Button
                          variant="xtra_small"
                          className={styles.viewall}
                          onClick={() => {
                            localStorage.setItem("cardType", selectedCard);
                            navigate(ROUTES.RECENT_TRANSACTIONS)
                          }}
                        >
                          View All
                        </Button>
                      </div>
                      <ul className={cardtransaction?.length > 0 ? '' : styles.noRecordList}>
                        {cardtransaction && cardtransaction?.length > 0 ?
                          cardtransaction?.map((transaction, index) => (
                            <li key={index}>
                              <div className={styles.recent_transactions_left}>
                                <div className={styles.textbox}>
                                  <h6>{transaction.merchantName}</h6>
                                  <p>
                                    {transaction?.created_at &&
                                      !isNaN(
                                        new Date(transaction.created_at).getTime()
                                      )
                                      ? format(
                                        new Date(transaction.created_at),
                                        "dd MMM, yyyy"
                                      )
                                      : "Invalid date"}
                                    &nbsp; • &nbsp; {transaction.merchant_category}
                                  </p>
                                </div>
                              </div>
                              <div className={styles.recent_transactions_right}>
                                <h4>${transaction.amount}</h4>
                                <span>{transaction?.transaction_type_api === "spend" ? <RedArrowIcon /> : <GreenArrowIcon />}</span>
                              </div>
                            </li>
                          )) :
                          <li className={styles.no_record}>
                            <NoContent
                              className={styles.no_record}
                            />
                          </li>
                        }
                      </ul>
                    </div>
                  </Col>
                </Row>
              </div>
              <div className={styles.stblMoney_right_footer}>
                <h4>Card Controls</h4>
                <Row>
                  {footerData.map((items, index) => (
                    <Col
                      lg={3}
                      md={4}
                      sm={6}
                      xs={12}
                      key={index}
                      className="card_col"
                    >
                      <NavLink
                        to={items.tolink}
                        state={{ selectedCard }}
                        className={styles.cardLink}
                        onClick={(e) => {
                          if (cardData?.status !== "active") {
                            e.preventDefault();
                            toast.error("Please activate your card first");
                            return;
                          }
                          if (items.label === "Freeze Card") {
                            e.preventDefault();
                            setActionType("freeze");
                            generateOTP("freeze");
                            setShow(true);
                            setModalTitle("Freeze Card")
                          } else if (items.label === "View PIN") {
                            e.preventDefault();
                            generateOTP("pin");
                          } else if (items.label === "Set/Update PIN") {
                            e.preventDefault();
                            setShowViewPin(true);
                            return;
                          } else if (items.label === "Card Settings") {
                            localStorage.setItem("cardType", selectedCard);
                          }
                        }}
                      >
                        <span>{items.iconlinks}</span>
                        {items.label}
                      </NavLink>
                    </Col>
                  ))}
                </Row>
              </div>
            </div>
          </Col>
        </Row>
        {show &&
          <AddPinModal
            show={show}
            handleClose={() => {
              setShow(false);
              setDonotLink(false);
            }}
            donotLink={donotLink}
            onSubmitAction={handleOtpSubmit}
            title={modalTitle}
            cardData={cardData}
          />}
      </section>
      {showtop &&
        <TopUpModals
          show={showtop}
          handleClose={() => setShowtop(false)}
          cardId={cardId}
          setUpdate={setUpdate}
        />}

      {showViewPin &&
        <ViewCardPin
          show={showViewPin}
          handleClose={() => setShowViewPin(false)}
          cardId={cardId}
          setUpdate={setUpdate}
        />}
      {showViewCardOtpModal &&
        <ViewCardOtpModal
          show={showViewCardOtpModal}
          handleClose={() => setshowViewCardOtpModal(false)}
          onSubmitAction={viewCard}
          loading={loading}
        />}
      {cancelCardShow &&
        <CancelCardModal
          show={cancelCardShow}
          handleClose={() => { setCancelCardShow(false) }}
          onSubmitAction={handleOtpSubmit}
          cardData={cardData}
        />}
    </>
  );
};

export default STBLMoney;
